import React, {useContext} from "react";
import ToggleSwitch from "../components/ToggleSwitch/ToggleSwitch";
import StyleContext from "../contexts/StyleContext";
import "./LabPages.scss";

export default function LabShell({eyebrow, title, intro, children}) {
  const {isDark} = useContext(StyleContext);
  const returnToLab = event => {
    event.preventDefault();
    window.location.hash = "mission-lab";
    window.location.reload();
  };
  return (
    <main className={isDark ? "lab-page lab-page-dark" : "lab-page"}>
      <nav className="lab-nav">
        <a className="lab-brand" href="#mission-lab" onClick={returnToLab}>Avik Banerjee</a>
        <div className="lab-nav-actions">
          <a href="#mission-lab" onClick={returnToLab}>← Back to Mission Lab</a>
          <ToggleSwitch />
        </div>
      </nav>
      <header className="lab-hero">
        <p>{eyebrow}</p>
        <h1>{title}</h1>
        <span>{intro}</span>
      </header>
      {children}
    </main>
  );
}
